// export const backend_url = 'http://localhost:8008'
// export const backend_url = ''
export const backend_url = 'https://os.madfunny.co.za'

export const base_url_toonflix = 'https://backendos.toon-flix.com'
// export const base_url_toonflix = 'http://192.168.1.13:8810'

